// Migrated version of the component using Material UI v5 and DataGrid from @mui/x-data-grid

import React, { Component } from 'react';
import './PerfilMobiliarioCorrectivos.css'; 
import { subirEvidenciaMtoCorrectivoActivo, getMtosCorrectivosActivo, clearErrors, deleteCorrectivoActivo } from '../../../redux/actions/mobiliarioactions';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, Button, CircularProgress, Typography, Tooltip, IconButton } from '@mui/material';
import { DataGrid, esES} from '@mui/x-data-grid';
import { FaArrowLeft, FaPlus, FaFilePdf, FaCheck, FaTrash, FaCheckCircle, FaEye, FaUpload } from "react-icons/fa";
import MyButton from '../../../utils/MyButton';

class PerfilMobiliarioCorrectivos extends Component {
  state = {
    mtoid: '',
    errors: {},
    open: false,
    opendelete: false,
    openadd: false,
    opensee: false,
    imageUrl: null,
    selectedFile: null,
    selectedFileUrl: null,
    aprobado: {},
  };

  componentDidMount() {
    this.props.getMtosCorrectivosActivo(this.props.mobiliarioId);
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpenDelete = (mtoid) => {
    this.setState({ opendelete: true, mtoid, errors: {}, aprobado: {} });
  };

  handleCloseDelete = () => {
    if (this.state.aprobado.mensaje) {
      this.props.getMtosCorrectivosActivo(this.props.mobiliarioId);
    }
    this.setState({ opendelete: false, errors: {}, aprobado: {} });
  };

  handleDelete = () => {
    this.props.deleteCorrectivoActivo(this.state.mtoid, this.props.equipoId);
  };

  handleOpenAdd = (mtoid) => {
    this.setState({ openadd: true, mtoid, errors: {}, aprobado: {} });
  };

  handleCloseAdd = () => {
    if (this.state.aprobado.mensaje) {
      this.props.getMtosCorrectivosActivo(this.props.mobiliarioId);
    }
    this.setState({ openadd: false, selectedFileUrl: null, errors: {}, aprobado: {}, evidencia: null });
  };

  onFileChange = (event) => {
    this.setState({
      selectedFile: event.target.files[0],
      selectedFileUrl: URL.createObjectURL(event.target.files[0])
    });
  };

  onFileUpload = (event) => {
    event.preventDefault();
    const formData = new FormData();
    formData.append("myFile", this.state.selectedFile, this.state.selectedFile.name);
    this.props.subirEvidenciaMtoCorrectivoActivo(formData, this.state.mtoid);
  };

  handleOpenSee = (mtoid, imageUrl) => {
    this.setState({ opensee: true, mtoid, imageUrl });
  };

  handleCloseSee = () => {
    this.setState({ opensee: false, errors: {}, imageUrl: null });
  };

  render() {
    const { mtoscorrectivosmobiliario, loadingmto } = this.props.dataMob;
    const { loading } = this.props.UI;

    const rows = mtoscorrectivosmobiliario.map((row, index) => ({
      id: index,
      ...row
    }));

    const columns = [{
        field: 'acciones',
        headerName: 'Acciones',
         flex:1, minwidth:120,
        sortable: false,
        renderCell: (params) => (
          <Box display="flex" gap={1}>
            <Tooltip title="Ver PDF">
              <IconButton  size="small"
                          color="primary" component={Link} to={`/dashboard/perfilcliente/mobiliario/${this.props.clienteId}/${this.props.mobiliarioId}/reportepdfcorr/${params.row.mtoid}`}>
                <FaFilePdf />
              </IconButton>
            </Tooltip>
            <Tooltip title="Borrar">
              <IconButton size="small"
                          color="primary" onClick={() => this.handleOpenDelete(params.row.mtoid)}>
                <FaTrash />
              </IconButton>
            </Tooltip>
            <Tooltip title="Ver evidencia">
              <IconButton size="small"
                          color="primary" onClick={() => this.handleOpenSee(params.row.mtoid, params.row.imageUrl)}>
                <FaEye />
              </IconButton>
            </Tooltip>
            <Tooltip title="Subir evidencia">
              <span>
                <IconButton size="small"
                          color="primary" onClick={() => this.handleOpenAdd(params.row.mtoid)} disabled={params.row.estado === 'Atendida'}>
                  <FaUpload />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        )
      },
      { field: 'fecha', headerName: 'Fecha', flex:1, minwidth:120},
      { field: 'horainicio', headerName: 'Hora Inicio', flex:1, minwidth:120},
      { field: 'horafinal', headerName: 'Hora Final', flex:1, minwidth:120},
      
    ];

    return (
      <Box sx={{ p: 2 }}>
        {loadingmto ? (
          <CircularProgress />
        ) : (
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={5}
            autoHeight
            rowsPerPageOptions={[5, 10, 20]}
             localeText={esES.components.MuiDataGrid.defaultProps.localeText}
             sx={{
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    boxShadow: 3,
                    '& .MuiDataGrid-cell': {
                      fontSize: 14,
                    },
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: '#0588FB',
                      color: '#fff',
                      fontWeight: 'bold',
                      fontSize: 15,
                    },
                    '& .MuiDataGrid-row:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                  }}
          />
        )}

        <Dialog open={this.state.opendelete} onClose={this.handleCloseDelete} fullWidth maxWidth="sm">
          {this.state.aprobado.mensaje ? (
            <Box p={3} textAlign="center">
             <div className='div-aprobado'>
                                    <div className='div-icono-delete'>
                                      <FaTrash color="#ffffff" className='icono-aprobado' />
                                    </div>
                                    <h2 className='text-aprobado'>Mantenimiento Borrado Exitosamente</h2>
                                  </div>
            </Box>
          ) : (
            <>
              <DialogTitle>¿Estás seguro de borrar este Mantenimiento?</DialogTitle>
              <DialogActions>
                <MyButton tip="Cerrar" onClick={this.handleCloseDelete}><FaArrowLeft color="#D3D7DC" className="icon-formulario" /></MyButton>
                                     {loading ? (
                                       <CircularProgress size={30} color="primary" className="login-progress" />
                                     ) : this.state.aprobado.mensaje ? (
                                       <MyButton tip="Continuar" onClick={this.handleCloseDelete}><FaCheckCircle color="#f9044e" className="icon-formulario" /></MyButton>
                                     ) : (
                                       <MyButton tip="Borrar Mantenimiento" onClick={this.handleDelete}><FaTrash color="#03178C" className="icon-formulario" /></MyButton>
                                     )}
              </DialogActions>
            </>
          )}
        </Dialog>

        <Dialog open={this.state.openadd} onClose={this.handleCloseAdd} fullWidth maxWidth="sm">
          <DialogTitle>Cargar Evidencia</DialogTitle>
          <DialogContent>
            {this.state.aprobado.mensaje ? (
              <div className='div-aprobado'>
                <div className='div-icono-aprobado'>
                  <FaCheck color="#ffffff" className='icono-aprobado' />
                </div>
                <h2 className='text-aprobado'>Evidencia Cargada Exitosamente</h2>
              </div>
            ) : (
              <>
                <div
                  onClick={() => this.fileInputRef.click()}
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={(e) => {
                    e.preventDefault();
                    const file = e.dataTransfer.files[0];
                    if (file) {
                      this.setState({ selectedFile: file, selectedFileUrl: URL.createObjectURL(file) });
                    }
                  }}
                  style={{
                    border: '2px dashed #aaa',
                    borderRadius: '10px',
                    padding: '30px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    backgroundColor: '#f9f9f9',
                  }}
                >
                  {this.state.selectedFile ? (
                    <Typography variant="body2">Archivo seleccionado: {this.state.selectedFile.name}</Typography>
                  ) : (
                    <Typography variant="body2">Haz clic o arrastra un archivo aquí</Typography>
                  )}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  ref={(ref) => (this.fileInputRef = ref)}
                  style={{ display: 'none' }}
                  onChange={this.onFileChange}
                />
                {this.state.selectedFileUrl && (
                  <img src={this.state.selectedFileUrl} alt="Preview" style={{ width: '100%', marginTop: '1rem' }} />
                )}
              </>
            )}
          </DialogContent>
            <DialogActions>
            <MyButton tip="Cerrar" onClick={this.handleCloseAdd}>
                               <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
                           </MyButton>
                           {loading ? (
                                         <CircularProgress size={30} color="primary" className="login-progress" />
                                       ) : this.state.aprobado.mensaje ? (
                                         <MyButton tip="Continuar" onClick={this.handleCloseAdd}><FaCheckCircle color="#20B90C" className="icon-formulario" /></MyButton>
                                       ) : (
                                           <MyButton
                                           tip="Subir Evidencia"
                                           onClick={this.onFileUpload}
                                           disabled={!this.state.selectedFile}
                                       >
                                           <FaPlus color="#03178C" className="icon-formulario" />
                                       </MyButton>
                                     )}
          </DialogActions>
        </Dialog>

         <Dialog open={this.state.opensee} onClose={this.handleCloseSee} fullWidth maxWidth="sm">
          <DialogTitle>Evidencia Cargada</DialogTitle>
          <DialogContent>
            {this.state.imageUrl ? (
              <Box display="flex" justifyContent="center">
                <img src={this.state.imageUrl} alt="Evidencia" style={{ maxWidth: '100%', maxHeight: '400px' }} />
              </Box>
            ) : (
              <Typography>No hay evidencia cargada para mostrar.</Typography>
            )}
          </DialogContent>
          <DialogActions>
           <MyButton tip="Cerrar" onClick={this.handleCloseSee}>
                               <FaArrowLeft color="#D3D7DC" className="icon-formulario" />
                           </MyButton>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }
}

PerfilMobiliarioCorrectivos.propTypes = {
  subirEvidenciaMtoCorrectivoActivo: PropTypes.func.isRequired,
  getMtosCorrectivosActivo: PropTypes.func.isRequired,
  dataMob: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
  deleteCorrectivoActivo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dataMob: state.dataMob,
  UI: state.UI
});

const mapActionsToProps = {
  subirEvidenciaMtoCorrectivoActivo,
  getMtosCorrectivosActivo,
  clearErrors,
  deleteCorrectivoActivo
};

export default connect(mapStateToProps, mapActionsToProps)(PerfilMobiliarioCorrectivos);
